import { createElement } from 'react';
import { t as CollectionList$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var CollectionList = function CollectionList(props) {
  return /*#__PURE__*/createElement(CollectionList$1, __assign({}, props));
};
CollectionList.displayName = 'CollectionList';

export { CollectionList };
